import React from 'react'
import './hero.css'
import { BsWhatsapp } from "react-icons/bs";

import { Col, Container, Row } from 'react-bootstrap';
// import  bgPelabuhan  from '../../assets/image/bg-pelabuhan.jpg';
import { BgPelabuhan ,KurirIcon } from './../../../assets/image';

const bgImage = {
backgroundImage: `url(${BgPelabuhan})`,
backgroundSize: 'cover',
backgroundPosition: 'center',
backgroundRepeat: 'no-repeat',
// height: '100vh',
}

const Hero = () => {
  return (
    <div className="hero-section" style={bgImage}>
      <div className="hero-content">   
        <Container className='h-100 '> 
          <Row className=" text-white  h-100 ">
            <Col xs={12} md={6} className="d-flex align-items-center ">
              <div className="hero-left-content ">
                <h1 className="hero-title">HBU Express</h1>               
                 <ul className="list-unstyled">
                  <li>Jasa Ekspedisi</li>
                  <li>Laut, Udara & Darat</li>
                  <li>Terpercaya</li>
                </ul>
                <p>Kami berkomitmen untuk selalu menjaga kepercayaan dan kepuasan 
              pelanggan dengan memberikan service yang terbaik dan termurah 
              sesuai dengan kebutuhan anda..</p>
                  
                  <button className="btn "><BsWhatsapp size={25}/>  Konsultasi Gratis</button>
              </div>   
            </Col>
            
            <Col xs={12} md={6} className=" hero-right-col  ">
              
                <div className="hero-right-content">
                  <img src={KurirIcon} alt="Kurir Icon" className="kurir-icon" />
                </div>
                
            </Col>
          </Row>
        </Container>
      </div>
    </div>
    


      // <div className="hero-section" style={bgImage}>  
      // <div className="hero-content">
      //  <div >
      //   <h1 className="hero-title">HBU Express</h1>
      //   <p className="hero-subtitle">Layanan Pengiriman Barang Terpercaya</p>
      //  </div>
      //   <Container className="text-center text-white border">
      //     <h1>Selamat Datang di HBU Express</h1>
      //     <p>Kami menyediakan layanan pengiriman barang yang cepat dan terpercaya.</p>
      //     <button className="btn btn-primary">Pelajari Lebih Lanjut</button>
      //   </Container>
      //   <Container className="hero-overlay">
      //     <h2>Pengiriman Cepat dan Aman</h2>
      //   </Container>
      // </div>       
      // </div>
  )
}

export default Hero